import { CollapsibleSection } from "../CollapsibleSection";

interface DevotionalMemoryVerseProps {
  reference: string;
  text: string;
  id?: string;
}

export const DevotionalMemoryVerse = ({ reference, text, id }: DevotionalMemoryVerseProps) => {
  return (
    <CollapsibleSection title="Weekly Memory Verse" id={id}>
      <p className="text-sage-600 font-medium mb-2 text-center font-serif text-lg">
        {reference}
      </p>
      <p className="font-serif text-lg leading-relaxed text-center text-justify italic">
        {text}
      </p>
    </CollapsibleSection>
  );
};